<div class="page">
  <header>
    <a class="back-link" uiSref="project">
      <span class="material-icons" aria-hidden="true">arrow_back</span>
      Projects Board
    </a>
    <h1 class="page-h__title">
      Projects tagged
      @for (tag of tagList; track tag) {
        @if (!$first) {<span class="sr-only">, </span>}
        <span class="tag-list__tag">{{ tag }}</span>
      }
    </h1>
  </header>

  <p class="sr-only" role="status">{{ status }}</p>
  <ul class="list">
    @for (project of projects.feedItems; track project.id) {
      <li><ut-project-card [project]="project" [feed]="projects"></ut-project-card></li>
    }
  </ul>

  @if (!projects.isLastPage) {
    <button type="button" class="ut-btn ut-btn--secondary more" [disabled]="projects.isLoading" (click)="loadMore()">
      {{ projects.isLoading ? 'Loading…' : 'View more' }}
    </button>
  }
</div>
